<template>
    <div id="cookie" class="animated fadeInUp" v-if="!isCookie">
        <div class="flex flex-col lg:flex-row items-start lg:items-end lg:justify-between my-0 lg:my-3 w-100" data-nosnippet>
            <div class="lg:mr-5 mb-8 lg:mb-0">
                <h5 class="mt-0 mb-1 text-xl font-normal" data-nosnippet>{{ translate('cookie_header') }}</h5>
                <p class="cookie-message" data-nosnippet>{{ translate('cookie_description') }}</p>
            </div>
            <a class="ok-button" @click="onClickOkHandler" href="javascript:void(0)">{{ translate('cookie_button_ok') }}</a>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import appConfig from '@/app.config.js'
import helperMixins from '@/mixins/helper.js'

export default {
    name: 'cookie',

    data () {
        return {
            cookieKey: appConfig.cookieConsentName,
            isCookie: true
        }
    },

    mixins: [
        helperMixins
    ],

    created () {
        let params = new URLSearchParams(window.location.search)
        if (!params.get('embed')) {
            this.checkCookieExist()
        }
    },

    methods: {

        onClickOkHandler () {
            this.isCookie = true
            Cookies.set(this.cookieKey, 1, {
                expires: 360
            })
        },

        checkCookieExist() {
            var contsent = Cookies.get(this.cookieKey)
            if (!contsent) {
                this.isCookie = false
            }
        }
    }
}
</script>


<style lang="scss" scoped>
#cookie {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    background-color: rgba(0, 0, 0, .6);
    padding: .8rem;
    color: #fff;

    .cookie-message {
        margin: 0;
        font-size: .8rem;
    }

    .ok-button {
        border: 1px solid #fff;
        padding: .6rem 2rem;
        color: #fff;
        text-decoration: none;

        @media (max-width: 575px) {
            padding: .4rem 1rem;
        }
    }
}
</style>
